// extracted by mini-css-extract-plugin
export var card = "_jb-5";
export var cardSelected = "_jb-4";
export var image = "_jb-3";
export var modal = "_jb-0";
export var modalContent = "_jb-1";
export var table = "_jb-2";